import { render, staticRenderFns } from "./StrapiEvenementComponent.vue?vue&type=template&id=037bec2a"
import script from "./StrapiEvenementComponent.vue?vue&type=script&lang=js"
export * from "./StrapiEvenementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports